import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import i18next from 'i18next';
import { Redirect } from 'react-router';
import Chains from './Chains';
import Restaurants from './Restaurants';
import { hasBusinessPermission } from '../../../helpers/permissions';

const BusinessHome = (props) => {
    
    const chains = useSelector(state => state.businessApp.chains);
    const restaurants = useSelector(state => state.businessApp.restaurants);
    const [currentTab, setTab] = useState('branches');    

    const menuItems = [];
    if (chains.length) menuItems.push({ key: 'chains', title: i18next.t('navChainsTitle') });
    if (restaurants.length) menuItems.push({ key: 'branches', title: i18next.t('navRestaurantsTitle') });
    if (hasBusinessPermission('operation')) menuItems.push({ key: 'archive', title: i18next.t('archiveRestaurantsTitle') });

    if (!menuItems.length) return null;

    function renderContent() {
        switch (currentTab) {
            case 'chains':
                return <Chains key={'chains'} {...props} />;
            case 'branches':
                return <Restaurants key={'branches'} {...props} />;
            case 'archive':
                return <Restaurants key={'archive'} {...props} deletedOnly />;
            default:
                return null;
        }
    }

    if (!chains.length && restaurants.length === 1) {
        return <Redirect to={{ pathname: `/restaurant/${restaurants[0].id}` }} />;
    }

    return (
        <div>
            <Menu widths={menuItems.length}>
                {menuItems.map(mi => <Menu.Item key={mi.key} name={mi.title} active={currentTab === mi.key} onClick={() => setTab(mi.key)} />)}
            </Menu>

            {renderContent()}
        </div>
    );
};

BusinessHome.propTypes = {
    
};

export default BusinessHome;